"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const noop_1 = __importDefault(require("lodash/noop"));
const tooltip_1 = __importDefault(require("../tooltip/tooltip"));
require("../../styles/components/actions-select.less");
const VisibleActions = (props) => {
    const { actions } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null, actions.map((action, idx) => (react_1.default.createElement(tooltip_1.default, { title: action.tooltip || action.name, placement: "bottom", key: `${action.name}-${idx}` },
        react_1.default.createElement("div", { className: (0, classnames_1.default)('action-icon', { disabled: action.disabled }), onClick: action.disabled ? noop_1.default : action.onClick }, action.icon))))));
};
exports.default = VisibleActions;
//# sourceMappingURL=visible-actions.js.map